/**
 * UI hints for budget dialog. Source of truth for procedures lives in
 * the `surgery_pricing_procedures` Mongo collection — fetched via
 * `surgeryBudgetsAPI.getProcedures()`. This file only keeps static
 * helpers that don't depend on the network.
 */

export const SURGERY_STAY_CODES = [
  { value: 'ES',  label: 'Habitación' },
  { value: 'ESM', label: 'Media estancia' },
  { value: 'ESU', label: 'UCI' },
];

export const TEST_CATEGORY_LABELS = {
  preoperatorio: 'Preoperatorio',
  anatomia_patologica: 'Anatomía patológica',
  imagen: 'Imagen / radiología',
};
